import { Component, Element, Method, Prop, h } from '@stencil/core';

import { onUseTradeInValueEvent } from '../../../actions/actions.eligibility';
import { AnswerVehicle } from '../../../interfaces/interface.vehicle';
import { trackVehDetail } from '../../../tracking/tracking.detail';

@Component({
  tag: 'ineligible-vehicle-modal',
  styleUrl: 'ineligible-vehicle-modal.css',
})
export class IneligibleVehicleModal {
  @Element() el: HTMLElement;
  @Prop() ineligibleReason = '';
  @Prop() dealershipName = '';
  @Prop() dealerId = '';
  @Prop() isDigitalRetailing: boolean = false;
  @Prop() vehicle: AnswerVehicle;

  @Method()
  async open() {
    const modal = this.el.querySelector('ico-modal#excluded-ted') as HTMLIcoModalElement;
    modal.open();
    trackVehDetail('continueErrIneligible', 'impression');
  }

  closeModal() {
    const modal = this.el.querySelector('ico-modal#excluded-ted') as HTMLIcoModalElement;
    modal.close();
  }

  onUseTradeInValue() {
    onUseTradeInValueEvent(this.vehicle, this.ineligibleReason);
    this.closeModal();
  }

  renderUnassignedLinks() {
    const placeAnAdUrl = 'https://www.autotrader.com/sell-my-car/?LNX=KBBATATCSELLHOME';
    const getMyCarValueUrl = 'https://www.kbb.com/whats-my-car-worth/';
    return (
      <div>
        <h2 class="font-semibold text-xl mb-4 font-ico-heading text-ico-heading">We Can Still Help</h2>
        <div class="mb-4">
          <h3 class="font-extrabold text-sm mb-2 font-ico-heading text-ico-heading">Sell Your Car Online</h3>
          <div class="text-sm mb-2">You control the price. You approve the sale.</div>
          <ico-hyperlink noUnderline href={placeAnAdUrl} target="_blank" onClick={() => trackVehDetail('linkAdIneligible', 'click')}>
            Place an Ad
          </ico-hyperlink>
        </div>
        <div>
          <h3 class="font-extrabold text-sm mb-2 font-ico-heading text-ico-heading">Get Your Kelley Blue Book® Values</h3>
          <div class="text-sm mb-2">Get your vehicle's Trade-in and Private Party Value.</div>
          <ico-hyperlink noUnderline href={getMyCarValueUrl} target="_blank" onClick={() => trackVehDetail('linkCarValueIneligible', 'click')}>
            Get My Car's Value
          </ico-hyperlink>
        </div>
      </div>
    );
  }

  renderAssignedLinks() {
    return (
      <div>
        <h3 class="font-semibold text-xl text-left pb-2 font-ico-heading text-ico-heading">Still looking to sell or trade-in your vehicle?</h3>
        <h4 class="text-sm text-left font-normal pb-4">
          {this.dealershipName} may still be interested in your vehicle. Please contact {this.dealershipName} about getting your vehicle appraised today.
        </h4>
      </div>
    );
  }

  renderAssignedAndDrFlaggedLinks() {
    return (
      <div>
        <h3 class="font-semibold text-xl text-left pb-2 font-ico-heading text-ico-heading">Still looking to trade-in your vehicle?</h3>
        <h4 class="text-sm text-left font-normal pb-4">
          {this.dealershipName} may still be interested in your vehicle as a trade-in. Please continue by getting your trade-in value instead.
        </h4>
        <div class="w-full flex justify-center mdLrg:justify-end">
          <ico-button class="w-fit mt-3" label="Use Trade-In Value Instead" buttonSize="large" whenClicked={() => this.onUseTradeInValue()} />
        </div>
      </div>
    );
  }

  render() {
    const isAssigned = this.dealershipName.length > 0;
    const isDrFlagged = isAssigned && this.isDigitalRetailing;
    return (
      <ico-modal displayX={true} id="excluded-ted">
        <h2 slot="header" class="font-semibold text-2xl font-ico-heading text-ico-heading">
          Sorry, This Vehicle Is Not Eligible
        </h2>
        <div slot="main" class="max-w-[640px] font-ico-body">
          <div class="text-sm pb-6">
            Based on the {this.ineligibleReason} selected, this vehicle isn't eligible for an Instant Cash Offer. If you selected the wrong {this.ineligibleReason}, please close
            this overlay and make the correction to move forward.
          </div>

          {!isAssigned && this.renderUnassignedLinks()}
          {isAssigned && !isDrFlagged && this.renderAssignedLinks()}
          {isAssigned && isDrFlagged && this.renderAssignedAndDrFlaggedLinks()}
        </div>
      </ico-modal>
    );
  }
}
